import { render, staticRenderFns } from "./PopupFullPreview.vue?vue&type=template&id=f6ab2574&"
import script from "./PopupFullPreview.vue?vue&type=script&lang=js&"
export * from "./PopupFullPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports